"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = exports.USER_AUTH_COOKIE_NAME = exports.REFRESH_TOKEN_KEY = exports.USER_AUTH_KEY = void 0;
exports.USER_AUTH_KEY = '_baas_ua';
exports.REFRESH_TOKEN_KEY = '_baas_rt';
exports.USER_AUTH_COOKIE_NAME = 'baas_ua';
exports.DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = 10;
//# sourceMappingURL=Common.js.map